import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import CleanLayout from "./Layouts/CleanLayout.vue";
import './../sass/app.scss'
import i18n from "./Plugins/i18n.js";
import * as Bootstrap from "bootstrap"
import Echo from "./Plugins/Echo.js";

export default createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.vue', { eager: true })
        let page = pages[`./Pages/${name}.vue`]
        page.default.layout = page.default.layout || CleanLayout
        return page;
    },
    setup({el, App, props, plugin}) {
        const Vue = createApp({render: () => h(App, props)});

        Vue.config.globalProperties.$echo = Echo;
        Vue
            .use(i18n)
            .use(plugin)
            .mount(el)
    }
})
